import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IUserState } from '../models';


const initialState: IUserState = {
  loading: false,
  name: '',
  last_name: '',
  phone: undefined,
  role: 0,
  premium: false,
  subjects: null,
  image: '',
  birthday: '',
  gender: '',
  email: '',
  region: { id: '', parent_id: null, name: '' },
  district: null
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<IUserState>>) => {
      Object.assign(state, action.payload);
    },    
    resetUser: () => initialState,
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    }
  }
});

export const { setUser, resetUser, setLoading } = userSlice.actions;
export const userReducer = userSlice.reducer;
